import { render, staticRenderFns } from "./single-product.vue?vue&type=template&id=38e37d74&scoped=true"
import script from "./single-product.vue?vue&type=script&lang=js"
export * from "./single-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e37d74",
  null
  
)

export default component.exports